import React, { useEffect, useState } from "react";
import I18n from "i18n";
import usersInstance from "collections/usersInstance";
import concurrentSelectionManager from "models/concurrentSelectionManager";

interface Props {
  agentResult: any; // Backbone.Model
}

export default function DetailAgentEditWarning({ agentResult }: Props) {
  const [fullname, setFullname] = useState<string | undefined>();

  useEffect(() => {
    function updateWarning() {
      const concurrentSelection = concurrentSelectionManager.getSelectionForId(agentResult.id);
      if (concurrentSelection) {
        const userId = concurrentSelection.get("userId");
        const user = usersInstance.get(userId);
        if (user) {
          setFullname(user.get("full_name"));
          return;
        }
      }
      setFullname(undefined);
    }

    updateWarning();

    concurrentSelectionManager.on("change", updateWarning);
    return () => {
      concurrentSelectionManager.off("change", updateWarning);
    };
  }, [agentResult.id]);

  if (!fullname) return null;

  return (
    <div className="edit-warning mbm">
      {I18n.t("webapp.agents.results.result_details.edit_warning", { fullname })}
    </div>
  );
}